import type { Dispatch } from 'react';
import type { UseFieldArrayReturn } from 'react-hook-form';

import { createContext, use } from 'react';
import invariant from 'tiny-invariant';

import type { FormWithLines } from '../FormLines';

export const LinesSectionContext = createContext<{
  linesFieldArray: UseFieldArrayReturn<FormWithLines, `sections.${number}.lines`>;
  mobileLineReducer: [string | null, Dispatch<{ lineIndex: number; sectionIndex: number } | null>];
  required: boolean;
  section: FormWithLines['sections'][number];
  sectionIndex: number;
  sectionsFieldArray: UseFieldArrayReturn<FormWithLines, 'sections'>;
} | null>(null);

export const useSectionContext = () => {
  const instance = use(LinesSectionContext);
  invariant(instance, 'Section components must be wrapped in <Section />');

  return instance;
};
